function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component, useState, useEffect } from 'react';
import { Icon } from '@els/els-react--icon';
import { createEnum, ValidPropTypes, makeErrorBoundComponent, generateId, appendClass } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';
var TogglePanelSizes = createEnum(['s', 'm', 'l']);
var TogglePanelHeaderLevels = createEnum(['1', '2', '3', '4', '5', '6']);
var arrayOf$1 = PT.arrayOf,
  bool$1 = PT.bool,
  element$1 = PT.element,
  func = PT.func,
  oneOf$1 = PT.oneOf,
  oneOfType$1 = PT.oneOfType,
  string$1 = PT.string;
var TogglePanel = /*#__PURE__*/function (_Component) {
  function TogglePanel() {
    var _this;
    _classCallCheck(this, TogglePanel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TogglePanel, [].concat(args));
    _defineProperty(_this, "state", {
      isPanelOpen: false,
      // An id is required to connect the button to the panel
      id: _this.props.id || "toggle-panel-".concat(generateId())
    });
    /**
     * Toggles the open/close state of the component.
     * If isControlled is false, it will set state with the new value.
     * If an onClick function is provided, it wil be called with the panel id and new open/close state as arguments
     */
    _defineProperty(_this, "toggleDropdown", function (event) {
      var _this$props = _this.props,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick,
        children = _this$props.children,
        isControlled = _this$props.isControlled,
        emptyContentRender = _this$props.emptyContentRender;
      var isPanelOpen = _this.state.isPanelOpen;
      if (!disabled && (!!children || !!emptyContentRender)) {
        if (!isControlled) {
          _this.setState({
            isPanelOpen: !isPanelOpen
          });
        }
      } else if (!children && !emptyContentRender) {
        _this.setState({
          isPanelOpen: false
        });
      }
      if (typeof onClick === "function" && event) {
        onClick(_this.state.id, !isPanelOpen, event);
      }
    });
    /**
     * Checks that required props are provided and are correctly typed.
     * This is necessary as the consuming application uses a production version of the component, which does not do prop-type checks
     */
    _defineProperty(_this, "validateProps", function () {
      var _this$props2 = _this.props,
        header = _this$props2.header,
        size = _this$props2.size;
      var id = _this.state.id;
      if (!header) {
        throw Error("A header must be provided to the panel component");
      }
      if (typeof id !== "string") {
        throw Error("TogglePanel id must be supplied as a string");
      }
      if (size !== TogglePanelSizes.S && size !== TogglePanelSizes.M && size !== TogglePanelSizes.L) {
        throw Error("TogglePanel size must be supplied as s, m, or l");
      }
    });
    return _this;
  }
  _inherits(TogglePanel, _Component);
  return _createClass(TogglePanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
        isOpen = _this$props3.isOpen,
        children = _this$props3.children,
        emptyContentRender = _this$props3.emptyContentRender;
      var isComponentOpen = (!!children || !!emptyContentRender) && isOpen;
      this.setState({
        isPanelOpen: isComponentOpen
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var oldIsOpen = prevProps.isOpen,
        oldChildren = prevProps.children;
      var _this$props4 = this.props,
        isOpen = _this$props4.isOpen,
        isControlled = _this$props4.isControlled,
        children = _this$props4.children;
      if (isControlled && oldIsOpen !== isOpen) {
        this.setState({
          isPanelOpen: isOpen
        });
      }
      if (!!oldChildren && !children) {
        this.toggleDropdown();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        children = _this$props5.children,
        className = _this$props5.className,
        disabled = _this$props5.disabled,
        emptyContentRender = _this$props5.emptyContentRender,
        header = _this$props5.header,
        headerLevel = _this$props5.headerLevel,
        onClick = _this$props5.onClick,
        size = _this$props5.size;
      var _this$state = this.state,
        id = _this$state.id,
        isPanelOpen = _this$state.isPanelOpen;
      this.validateProps();
      var panelDisabled = disabled || !children && !emptyContentRender && !onClick;
      var panelClasses = classnames("c-els-accordion__group", {
        "c-els-accordion--small": size === TogglePanelSizes.S
      }, {
        "c-els-accordion--large": size === TogglePanelSizes.L
      }, appendClass({
        className: className,
        value: "group",
        delimiter: "__"
      }), {
        "c-els-accordion__group--expanded": isPanelOpen
      }, {
        "c-els-accordion__group--disabled": panelDisabled
      });
      var iconSize;
      if (size === TogglePanelSizes.L) {
        iconSize = "m";
      } else if (size === TogglePanelSizes.S) {
        iconSize = "xs";
      } else {
        iconSize = "s";
      }
      var iconClasses = classnames("c-els-accordion__icon", {
        "c-els-accordion__icon--small": size === TogglePanelSizes.S
      }, {
        "c-els-accordion__icon--medium": size === TogglePanelSizes.M
      }, {
        "c-els-accordion__icon--large": size === TogglePanelSizes.L
      }, appendClass({
        className: className,
        value: "icon",
        delimiter: "__"
      }));
      var buttonClasses = classnames("c-els-accordion__button", appendClass({
        className: className,
        value: "button",
        delimiter: "__"
      }));
      var headerClasses = classnames("c-els-accordion__button-text", appendClass({
        className: className,
        value: "header",
        delimiter: "__"
      }));
      var bodyClasses = classnames("c-els-accordion__body", appendClass({
        className: className,
        value: "body",
        delimiter: "__"
      }));
      var bodyContentClasses = classnames("toggle-panel__body-content", "c-els-accordion__body-content", appendClass({
        className: className,
        value: "body-content",
        delimiter: "__"
      }));
      var HeaderElement = "h".concat(headerLevel);
      return /* @__PURE__ */React.createElement("div", {
        className: panelClasses,
        id: id,
        "data-testid": "toggle-panel"
      }, /* @__PURE__ */React.createElement(HeaderElement, null, /* @__PURE__ */React.createElement("button", {
        className: buttonClasses,
        onClick: this.toggleDropdown,
        "aria-expanded": isPanelOpen ? "true" : "false",
        "data-testid": "toggle-panel-button",
        disabled: panelDisabled,
        "aria-controls": "".concat(id, "-panel"),
        type: "button"
      }, /* @__PURE__ */React.createElement("span", {
        className: headerClasses
      }, header), (children || emptyContentRender) && /* @__PURE__ */React.createElement(Icon, {
        isDecorative: true,
        sprite: Icon.Sprites.CHEVRON_DOWN,
        className: iconClasses,
        size: iconSize,
        fallback: (/* istanbul ignore next */
        function fallback() {
          return "▼";
        })
      }))), isPanelOpen && /* @__PURE__ */React.createElement("div", {
        className: bodyClasses,
        id: "".concat(id, "-panel"),
        "data-testid": "toggle-panel-panel"
      }, /* @__PURE__ */React.createElement("div", {
        className: bodyContentClasses
      }, children || emptyContentRender)));
    }
  }]);
}(Component);
TogglePanel.displayName = "TogglePanel";
TogglePanel.propTypes = {
  /** children supplied to the component */
  children: oneOfType$1([arrayOf$1(element$1), element$1, string$1]),
  /** custom classname for the component */
  className: string$1,
  /** disables the panel */
  disabled: bool$1,
  /** optional render that displays if no children are passed to the component
  this prevents the TogglePanel from becoming disabled to do no children */
  emptyContentRender: oneOfType$1([string$1, element$1]),
  /** content to be displayed within the header. Can be either string or DOM elements */
  header: oneOfType$1([string$1, element$1]).isRequired,
  /** What header element level should be used around the toggle button */
  headerLevel: string$1,
  /** id applied to the top-level div within the TogglePanel component. This is used by TogglePanelCollection to determine open state */
  id: string$1,
  /** determines if the open/close state is maintained by the consuming component */
  isControlled: bool$1,
  /** if isControlled is set to true, this determines the open/close state of the TogglePanel.
   if isControlled is set to false, this determines the initial open state of the TogglePanel */
  isOpen: bool$1,
  /** size of the Accordion styling */
  size: oneOf$1(TogglePanelSizes.getAll()),
  /** method to be fired on click - id and the new open state are passed as an argument to this function */
  onClick: func
};
TogglePanel.requiredProps = {
  header: ValidPropTypes.NODE,
  headerLevel: ValidPropTypes.STRING
};
TogglePanel.defaultProps = {
  children: null,
  className: "",
  // This is always overridden by TogglePanelCollection, but supplying a default avoids a prop-type warning during initial render
  disabled: false,
  emptyContentRender: null,
  headerLevel: "3",
  id: null,
  isOpen: false,
  isControlled: false,
  size: TogglePanelSizes.M,
  onClick: null
};
TogglePanel.Sizes = TogglePanelSizes;
TogglePanel.HeaderLevels = TogglePanelHeaderLevels;
var RawTogglePanel = TogglePanel;
var ErrorBoundTogglePanel = makeErrorBoundComponent(RawTogglePanel);
var arrayOf = PT.arrayOf,
  bool = PT.bool,
  element = PT.element,
  oneOf = PT.oneOf,
  oneOfType = PT.oneOfType,
  string = PT.string;
var defaults = {
  canCloseAll: true,
  className: "",
  iconRight: false,
  id: null,
  isAccordion: false,
  initialOpenPanels: [],
  noBottomKeyline: false,
  noIndent: false,
  noTopKeyline: false,
  setOpenPanels: null,
  size: RawTogglePanel.Sizes.M,
  thinKeyline: false
};
var TogglePanelCollection = function TogglePanelCollection(_ref) {
  var _ref$canCloseAll = _ref.canCloseAll,
    canCloseAll = _ref$canCloseAll === void 0 ? defaults.canCloseAll : _ref$canCloseAll,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? defaults.className : _ref$className,
    headerLevel = _ref.headerLevel,
    _ref$iconRight = _ref.iconRight,
    iconRight = _ref$iconRight === void 0 ? defaults.iconRight : _ref$iconRight,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? defaults.id : _ref$id,
    _ref$initialOpenPanel = _ref.initialOpenPanels,
    initialOpenPanels = _ref$initialOpenPanel === void 0 ? defaults.initialOpenPanels : _ref$initialOpenPanel,
    _ref$isAccordion = _ref.isAccordion,
    isAccordion = _ref$isAccordion === void 0 ? defaults.isAccordion : _ref$isAccordion,
    _ref$noBottomKeyline = _ref.noBottomKeyline,
    noBottomKeyline = _ref$noBottomKeyline === void 0 ? defaults.noBottomKeyline : _ref$noBottomKeyline,
    _ref$noIndent = _ref.noIndent,
    noIndent = _ref$noIndent === void 0 ? defaults.noIndent : _ref$noIndent,
    _ref$noTopKeyline = _ref.noTopKeyline,
    noTopKeyline = _ref$noTopKeyline === void 0 ? defaults.noTopKeyline : _ref$noTopKeyline,
    _ref$setOpenPanels = _ref.setOpenPanels,
    setOpenPanels = _ref$setOpenPanels === void 0 ? defaults.setOpenPanels : _ref$setOpenPanels,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaults.size : _ref$size,
    _ref$thinKeyline = _ref.thinKeyline,
    thinKeyline = _ref$thinKeyline === void 0 ? defaults.thinKeyline : _ref$thinKeyline;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    initialActivePanels = _useState2[0],
    setInitialActivePanels = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    activePanels = _useState4[0],
    setActivePanels = _useState4[1];
  var _useState5 = useState({
      isAccordion: false,
      canCloseAll: false,
      initialOpenPanels: []
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    prevProps = _useState6[0],
    setPrevProps = _useState6[1];
  useEffect(function () {
    validateProps();
    getUpdatedOpenPanels(initialOpenPanels);
  }, [initialOpenPanels]);
  useEffect(function () {
    var hasIsAccordionUpdated = !prevProps.isAccordion && isAccordion;
    var hasCanCloseAllUpdated = prevProps.canCloseAll && !canCloseAll;
    var hasInitialOpenPanelsUpdated = !initialOpenPanels.every(function (panelid) {
      return prevProps.initialOpenPanels.includes(panelid);
    });
    if (hasIsAccordionUpdated || hasCanCloseAllUpdated) {
      getUpdatedOpenPanels(initialActivePanels);
    } else if (hasInitialOpenPanelsUpdated) {
      getUpdatedOpenPanels(initialOpenPanels);
    }
    setPrevProps(_objectSpread(_objectSpread({}, prevProps), {}, {
      isAccordion: isAccordion,
      canCloseAll: canCloseAll,
      initialOpenPanels: initialOpenPanels
    }));
  }, [initialActivePanels, canCloseAll, initialOpenPanels, activePanels]);
  var getUpdatedOpenPanels = function getUpdatedOpenPanels(openPanels) {
    var firstChildId = Array.isArray(children) ? children.find(function (child) {
      return !!child.props.children;
    }).props.id : children.props.id;
    var newOpenPanels;
    if (openPanels && openPanels.length) {
      if (isAccordion) {
        newOpenPanels = [openPanels[0]];
      } else {
        newOpenPanels = openPanels;
      }
    } else if (!canCloseAll || isAccordion) {
      newOpenPanels = [firstChildId];
    } else {
      newOpenPanels = [];
    }
    setInitialActivePanels(newOpenPanels);
    if (setOpenPanels) {
      var childrenId;
      setOpenPanels.length !== 0 && setOpenPanels[0].toString().toLowerCase().replace(/\s+/g, "") === "openall" && (childrenId = children.map(function (child) {
        return child.props.id;
      }));
      setOpenPanels.length === 0 && (childrenId = []);
      setOpenPanels.length >= 1 && setOpenPanels[0].toString().toLowerCase().replace(/\s+/g, "") !== "openall" && (childrenId = setOpenPanels);
      setActivePanels(childrenId);
    }
  };
  var changeInitialActivePanels = function changeInitialActivePanels(key) {
    var isPanelOpen = initialActivePanels.includes(key);
    var isActivePanelOpen = activePanels.includes(key);
    var newinitialActivePanels;
    var activePanelId;
    if (isAccordion) {
      newinitialActivePanels = [key];
      activePanelId = [key];
    } else {
      newinitialActivePanels = isPanelOpen ? initialActivePanels.filter(function (panel) {
        return panel !== key;
      }) : [].concat(_toConsumableArray(initialActivePanels), [key]);
      activePanelId = isActivePanelOpen ? activePanels.filter(function (panel) {
        return panel !== key;
      }) : [].concat(_toConsumableArray(activePanels), [key]);
    }
    setActivePanels(activePanelId);
    setInitialActivePanels(newinitialActivePanels);
  };
  var cloneChild = function cloneChild(child) {
    var _child$props = child.props,
      childId = _child$props.id,
      panelOnClick = _child$props.onClick,
      childClassName = _child$props.className,
      childDisabled = _child$props.disabled;
    var isPanelOpen = initialActivePanels.includes(childId);
    var isChildDisabled = childDisabled || !canCloseAll && isPanelOpen && initialActivePanels.length === 1 || isAccordion && isPanelOpen;
    return React.cloneElement(child, {
      isOpen: setOpenPanels ? activePanels.includes(childId) : initialActivePanels.includes(childId),
      onClick: function onClick(panelId, openState, event) {
        changeInitialActivePanels(panelId);
        if (panelOnClick) {
          panelOnClick(panelId, openState, event);
        }
      },
      isControlled: true,
      className: "".concat(className, " ").concat(childClassName),
      disabled: isChildDisabled,
      size: size,
      headerLevel: headerLevel
    });
  };
  var validateProps = function validateProps() {
    if (!children) {
      throw Error("Children must be passed to TogglePanelCollection");
    }
    var childrenToUse = Array.isArray(children) ? children : [children];
    if (childrenToUse.some(function (child) {
      return ![RawTogglePanel, ErrorBoundTogglePanel].includes(child.type);
    })) {
      throw Error("children passed to TogglePanelCollection must be the TogglePanel component");
    }
    var panelIds = childrenToUse.map(function (child) {
      return child.props.id;
    });
    panelIds.forEach(function (key) {
      var numberOfKeyUses = panelIds.filter(function (currentKey) {
        return currentKey === key;
      }).length;
      if (numberOfKeyUses > 1) {
        throw Error("all togglePanel ids must be unique within a TogglePanelCollection");
      }
    });
    if (Array.isArray(setOpenPanels)) {
      var isAllString = setOpenPanels.every(function (item) {
        return typeof item === "string";
      });
      if (!isAllString) {
        throw Error("setOpenPanels array must contain panels id as string");
      }
      if (setOpenPanels.some(function (panelId) {
        return !panelIds.includes(panelId);
      })) {
        if (setOpenPanels.length === 1 && setOpenPanels[0].toString().toLowerCase().replace(/\s+/g, "") !== "openall") {
          throw Error("setOpenPanels array includes some unexpected Id's");
        } else if (setOpenPanels.length > 1) {
          throw Error("setOpenPanels array includes some unexpected Id's");
        }
      }
    } else if (setOpenPanels !== null) {
      throw Error("setOpenPanels must be array or null");
    }
  };
  validateProps();
  var collectionClasses = classnames("c-els-accordion", className, {
    "c-els-accordion--icon-right": iconRight,
    "c-els-accordion--no-bottom-keyline": noBottomKeyline,
    "c-els-accordion--no-indent": noIndent,
    "c-els-accordion--no-top-keyline": noTopKeyline,
    "c-els-accordion--thin-keyline": thinKeyline
  });
  return /* @__PURE__ */React.createElement("div", {
    className: collectionClasses,
    id: id,
    "data-testid": "toggle-panel-collection"
  }, React.Children.map(children, function (child) {
    return cloneChild(child);
  }));
};
TogglePanelCollection.Sizes = RawTogglePanel.Sizes;
TogglePanelCollection.HeaderLevels = RawTogglePanel.HeaderLevels;
TogglePanelCollection.displayName = "TogglePanelCollection";
TogglePanelCollection.propTypes = {
  /** determines if all panels can be closed at any given time or if one must remain open */
  canCloseAll: bool,
  /** only TogglePanel should be supplied to this component */
  children: oneOfType([arrayOf(element), element]).isRequired,
  /** custom className from the consuming component. This className gets passed to all children as well */
  className: string,
  /** What header element level should be used around the toggle button */
  headerLevel: string.isRequired,
  /** align the chevron to the right */
  iconRight: bool,
  /** id to be applied to interactive elements */
  id: string,
  /** DEPRECATED: panelKey of the TogglePanel that is initially open */
  initialOpenPanels: arrayOf(string),
  /** if isAccordion is set to true, only one TogglePanel may be open at a time */
  isAccordion: bool,
  /** suppress bottom keyline of whole set */
  noBottomKeyline: bool,
  /** remove left indentation for toggle panel content */
  noIndent: bool,
  /** suppress top keyline of whole set */
  noTopKeyline: bool,
  /** depends on value work with panels
   * if value is ['open all'], open all panels,
   * if value is [], close all panels,
   * if value is ['id1', 'id2'] or another id's, open panel with similar id
   * if value is undefined it uses initialActivePanels else activePanels
   */
  setOpenPanels: oneOfType([arrayOf(string), oneOf([void 0, null])]),
  /** size of the TogglePanels */
  size: string,
  /** Uses the thin keyline CSS modifier */
  thinKeyline: bool
};
TogglePanelCollection.requiredProps = {
  children: ValidPropTypes.NODE,
  headerLevel: ValidPropTypes.STRING
};
TogglePanelCollection.defaults = defaults;
var RawTogglePanelCollection = TogglePanelCollection;
var TogglePanelCollection$1 = makeErrorBoundComponent(RawTogglePanelCollection);
export { RawTogglePanel, RawTogglePanelCollection, ErrorBoundTogglePanel as TogglePanel, TogglePanelCollection$1 as TogglePanelCollection };
